import { render, staticRenderFns } from "./Bright.vue?vue&type=template&id=b6444d5c"
import script from "./Bright.vue?vue&type=script&lang=js"
export * from "./Bright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports